// ANCHOR React
import { FormEvent } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import { useUpdateFormFormTitle } from '@lyon/scoped-models/form/update/UpdateFormForm';

// ANCHOR Hooks
import { useConstantCallback } from '@lyon/utils/hooks/useConstantCallback';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { FormField } from '@lyon/components/utils/FormField';

// ANCHOR Constants
import { TITLE, PLACEHOLDER } from './constants';

export const LyonUpdateFormTitle = constant(() => {
  const [title, setTitle] = useUpdateFormFormTitle();

  const onChange = useConstantCallback((event: FormEvent<HTMLInputElement>) => {
    setTitle(event.currentTarget.value);
    event.stopPropagation();
  });

  return (
    <Block marginBottom="24px">
      <FormField
        value={title}
        onChange={onChange}
        placeholder={PLACEHOLDER}
        label={TITLE}
        required
      />
    </Block>
  );
});
